import { gql } from "@apollo/client";

export const getDistinctEvents = gql`
  query getDistinctEvents(
    $organisation_id: Int!
    $limit: Int
    $offset: Int
    $current_date: date
    $current_time: time
    $extra_filter: presentations_bool_exp!
  ) {
    presentations(
      distinct_on: title
      order_by: { title: asc }
      limit: $limit
      offset: $offset
      where: {
        _and: [
          {
            organisation_presentations: {
              organisation_id: { _eq: $organisation_id }
            }
          }
          { enabled: { _eq: true } }
          {
            _or: [
              {
                _and: [
                  { presentation_end_time: { _gt: $current_time } }
                  { presentation_date: { _eq: $current_date } }
                ]
              }
              { presentation_date: { _gt: $current_date } }
            ]
          }
          {
            _or: [
              { upload_start_date: { _lte: $current_date } }
              { upload_start_date: { _is_null: true } }
            ]
          }
          $extra_filter
        ]
      }
    ) {
      id
      title
      target_audience
      presentation_date
      presentation_end_time
      presentation_time
      upload_start_date
    }
    presentations_aggregate(
      distinct_on: title
      where: {
        _and: [
          {
            organisation_presentations: {
              organisation_id: { _eq: $organisation_id }
            }
          }
          { enabled: { _eq: true } }
          {
            _or: [
              {
                _and: [
                  { presentation_end_time: { _gt: $current_time } }
                  { presentation_date: { _eq: $current_date } }
                ]
              }
              { presentation_date: { _gt: $current_date } }
            ]
          }
          {
            _or: [
              { upload_start_date: { _lte: $current_date } }
              { upload_start_date: { _is_null: true } }
            ]
          }
          $extra_filter
        ]
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const getRelatedEvents = gql`
  query getRelatedEvents(
    $organisation_id: Int!
    $user_id: Int!
    $title: String
    $limit: Int
    $offset: Int
    $current_date: date
    $current_time: time
  ) {
    presentations(
      order_by: { presentation_date: asc }
      limit: $limit
      offset: $offset
      where: {
        _and: [
          {
            organisation_presentations: {
              organisation_id: { _eq: $organisation_id }
            }
          }
          { enabled: { _eq: true } }
          { title: { _eq: $title } }
          {
            _or: [
              {
                _and: [
                  { presentation_end_time: { _gt: $current_time } }
                  { presentation_date: { _eq: $current_date } }
                ]
              }
              { presentation_date: { _gt: $current_date } }
            ]
          }
          {
            _or: [
              { upload_start_date: { _lte: $current_date } }
              { upload_start_date: { _is_null: true } }
            ]
          }
        ]
      }
    ) {
      id
      title
      target_audience
      presentation_date
      number_of_places
      booked_places
      presentation_time
      presentation_end_time
      presentation_type
      webinar_link
      upload_start_date
      booked_user_presentations(
        where: {
          _and: [
            { user_id: { _eq: $user_id } }
            { organisation_id: { _eq: $organisation_id } }
          ]
        }
      ) {
        id
        email
        user_id
        cancelled_at
        attended
      }
    }
    presentations_aggregate(
      where: {
        _and: [
          {
            organisation_presentations: {
              organisation_id: { _eq: $organisation_id }
            }
          }
          { enabled: { _eq: true } }
          { title: { _eq: $title } }
          {
            _or: [
              {
                _and: [
                  { presentation_end_time: { _gt: $current_time } }
                  { presentation_date: { _eq: $current_date } }
                ]
              }
              { presentation_date: { _gt: $current_date } }
            ]
          }
          {
            _or: [
              { upload_start_date: { _lte: $current_date } }
              { upload_start_date: { _is_null: true } }
            ]
          }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const getPeronalBookings = gql`
  query getPeronalBookings(
    $organisation_id: Int!
    $user_id: Int!
    $limit: Int
    $offset: Int
    $current_date: date
    $current_time: time
  ) {
    booked_user_presentations(
      order_by: { presentation: { presentation_date: asc } }
      limit: $limit
      offset: $offset
      where: {
        _and: [
          { user_id: { _eq: $user_id } }
          { organisation_id: { _eq: $organisation_id } }
          { cancelled_at: { _is_null: true } }
          {
            presentation: {
              _and: [
                { enabled: { _eq: true } }
                {
                  _or: [
                    {
                      _and: [
                        { presentation_end_time: { _gt: $current_time } }
                        { presentation_date: { _eq: $current_date } }
                      ]
                    }
                    { presentation_date: { _gt: $current_date } }
                  ]
                }
                {
                  _or: [
                    { upload_start_date: { _lte: $current_date } }
                    { upload_start_date: { _is_null: true } }
                  ]
                }
              ]
            }
          }
        ]
      }
    ) {
      id
      user_id
      attended
      cancelled_at
      presentation_id
      organisation_id
      five_years_to_retirement
      presentation {
        id
        title
        webinar_link
        target_audience
        presentation_date
        presentation_time
        presentation_end_time
        presentation_type
        upload_start_date
      }
    }
    booked_user_presentations_aggregate(
      where: {
        _and: [
          { user_id: { _eq: $user_id } }
          { organisation_id: { _eq: $organisation_id } }
          { cancelled_at: { _is_null: true } }
          {
            presentation: {
              _and: [
                { enabled: { _eq: true } }
                {
                  _or: [
                    {
                      _and: [
                        { presentation_end_time: { _gt: $current_time } }
                        { presentation_date: { _eq: $current_date } }
                      ]
                    }
                    { presentation_date: { _gt: $current_date } }
                  ]
                }
                {
                  _or: [
                    { upload_start_date: { _lte: $current_date } }
                    { upload_start_date: { _is_null: true } }
                  ]
                }
              ]
            }
          }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const getWebinarAttendance = gql`
  query getWebinarAttendance($organisation_id: Int!, $user_id: Int!) {
    booked_user_presentations_aggregate(
      where: {
        _and: [
          { user_id: { _eq: $user_id } }
          { organisation_id: { _eq: $organisation_id } }
          { attended: { _eq: true } }
          { presentation: { presentation_type: { _eq: "Webinar" } } }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;
